import _ from 'lodash';

const getComments = state => state.comments;

const getEntityIdsByPage = (state, page) => {
  return state.pagination.comments.entitiesByPage[page] || [];
};

export const getCommentsByPostId = (state, postId) => getComments(state)[postId] || [];
export const getCommentsByPostIdAndPage = (state, postId, page) => {
  const entityIds = getEntityIdsByPage(state, page);
  const comments = getComments(state)[postId] || [];
  return _.filter(comments, comment => entityIds.indexOf(comment._id) > -1);
};

export const getComment = (state, commentId, postId) =>
  _.find(getCommentsByPostId(state, postId), comment => comment._id === commentId);



// WEBPACK FOOTER //
// ./app/selectors/comment-selectors.js